module.exports = __webpack_public_path__ + "img/mouse-square.19e1087e.svg";